import { api } from "../ConsumeApiController";
import CompanyRoutes from "../../apiRoutes/CompanyRoutes";

// 1. Obtener Estadísticas
export const getDashboardStats = async () => {
    try {
        const response = await api.get(CompanyRoutes.Bookings.GetStats);
        return response; // { success: true, data: {...} }
    } catch (error) {
        console.error("Error loading stats:", error);
        return { success: false, data: null };
    }
};

// 2. Obtener Recursos (Columnas: Empleados/Activos)
export const getCalendarResources = async () => {
    try {
        const response = await api.get(CompanyRoutes.Bookings.CalendarResource);
        return response.data; // Array de recursos [{id: 'emp_1', title: 'Juan'}, ...]
    } catch (error) {
        console.error("Error loading resources:", error);
        return [];
    }
};

// 3. Obtener Eventos (Las Citas) - FullCalendar pasa rangeInfo automáticamente
export const getCalendarEvents = async (rangeInfo) => {
    try {
        // rangeInfo.startStr y rangeInfo.endStr vienen en ISO8601
        const url = CompanyRoutes.Bookings.CalendarEvents(rangeInfo.startStr,rangeInfo.endStr);
        const response = await api.get(url);
        return response.data; // Array de eventos formateados por el Resource de Laravel
    } catch (error) {
        console.error("Error loading events:", error);
        return [];
    }
};

// 4. Actualizar (Drag & Drop)
export const updateBookingDrop = async (uuid, newStart, newEnd, newResourceId) => {
    try {
        const url = CompanyRoutes.Bookings.Update(uuid);
        const response = await api.put(url, {
            start_datetime: newStart,
            end_datetime: newEnd,
            resource_id: newResourceId // 'emp_5' o 'ast_2'
        });
        return response;
    } catch (error) {
        console.error("Error moving booking:", error);
        throw error;
    }
};

export async function updateBookingStatus(uuid,status){
    try{
        const url = CompanyRoutes.Bookings.UpdateStatus(uuid);
        const response = await api.post(url,{status});
        return response;
    }catch (error){

    }
}


//OPCIONES DE FORMULARIO (Servicios y Empleados)
export const getBookingFormOptions = async () => {
    try {
        const response = await api.get(CompanyRoutes.Bookings.GetFormOptions);
        return response.data; // { services: [], employees: [] }
    } catch (error) {
        console.error("Error cargando opciones:", error);
        return { services: [], employees: [] };
    }
};

//VERIFICAR DISPONIBILIDAD (Slots)
export const checkAdminAvailability = async (date, employeeId, duration) => {
    try {
        const response = await api.post(CompanyRoutes.Bookings.CheckAvailability, {
            date, 
            employee_id: employeeId,
            duration
        });
        return response.data; // Array de slots [{time: '08:00', status: 'free'}, ...]
    } catch (error) {
        console.error("Error verificando disponibilidad:", error);
        return [];
    }
};

// 4. CREAR (Ya la tenías, la dejo por referencia)
export const createManualBookingOLD = async (payload) => {
    try {
        const response = await api.post(CompanyRoutes.Bookings.Create, payload);
        return response.data;
    } catch (error) {
        return { success: false, message: error.response?.data?.message || 'Error desconocido' };
    }
};

export const createManualBooking = async (payload) => {
    try {
        // payload ahora será { customer_id: 1, bookings: [...] }
        const response = await api.post(CompanyRoutes.Bookings.Create, payload);
        return response;
    } catch (error) {
        console.error("Error creando reserva múltiple:", error);
        return { success: false, message: error.response?.data?.message || 'Error al crear la cita' };
    }
};